import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { FavouriteSectionType } from '../metroline/types';
import { FavouriteSection } from '../types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { getFavouriteName } from 'app/area/favourite-administration/form/components/helpers';
import { SectionList } from 'app/area/favourite-administration/form/components/section-list';

export const FavouriteDashboards: React.FC<FavouriteSection> = ({
  favouriteItem, mainLanguage, translation, section, getRef, shouldRenderSection
}) => {

  const favouriteName = getFavouriteName(favouriteItem, mainLanguage);

  return <MetroLineSection<FavouriteSectionType>
    section={section}
    sectionType={FavouriteSectionType.Dashboards}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(FavouriteSectionType.Dashboards)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={FavouriteSectionType.Dashboards}
        validation={undefined}
        info={{ visible: true, text: replaceTemplateString(translation.dashboards_description, favouriteName) }}
        label={{ visible: true, text: translation.dashboards_title }} />
      <MainGridContainer>
        <div className="row">
          <div className="col-12">
            {favouriteItem?.dashboards.length > 0
              ? <SectionList values={favouriteItem.dashboards} />
              : <p className="no-content">{translation.dashboards_no_message}</p>}
          </div>
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
